import Tracker from '@exodus/segment-metrics';
import validateEventDefault from '@exodus/analytics-validation';
const createAnalyticsTracker = ({ config, getBuildMetadata, logger, validateAnalyticsEvent = validateEventDefault, }) => new Tracker({
    writeKey: config.segment.apiKey,
    apiBaseUrl: config.segment.apiBaseUrl,
    validateEvent: validateAnalyticsEvent,
    logger,
    getBuildMetadata,
    preserveEventNames: config.segment.preserveEventNames,
    preservePropertyKeys: config.segment.preservePropertyKeys,
});
const analyticsTrackerDefinition = {
    id: 'analyticsTracker',
    // TODO: change to 'client'
    type: 'module',
    factory: createAnalyticsTracker,
    dependencies: ['config', 'getBuildMetadata', 'logger', 'validateAnalyticsEvent?'],
    public: true,
};
export default analyticsTrackerDefinition;
